import { createApi } from "@reduxjs/toolkit/query/react";
import fetchBaseQueryCSRF from "../helper";

const brandColorAPI = createApi({
    baseQuery: fetchBaseQueryCSRF({ baseUrl: process.env.CROSS_API_URL }),
    reducerPath: "api.brandColor",
    tagTypes: ["brandColor"],
    endpoints: (builder) => ({
        getBrandColors: builder.query<Record<string, string>, string[]>({
            query: (domains) => ({
                url: `/brand-color/batch?domains=${domains.join(",")}`,
                method: "GET",
            }),
            transformResponse: (response: { colors: Record<string, string> }) => response.colors,
        }),
    }),
});

export const { useGetBrandColorsQuery } = brandColorAPI;
export default brandColorAPI;
